import { shared } from '../components/NavIcons';

/** The portal's bottom-bar icons: the side nav's outline style, drawn a size up for a thumb. */
const big = { ...shared, width: '1.4rem', height: '1.4rem' };

export function TodayIcon() {
  return (
    <svg {...big}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4" />
      <circle cx="12" cy="15" r="2" />
    </svg>
  );
}

export function WeekIcon() {
  return (
    <svg {...big}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4M7.5 13.5h2M11 13.5h2M14.5 13.5h2M7.5 17h2M11 17h2" />
    </svg>
  );
}

export function OffersIcon() {
  return (
    <svg {...big}>
      <rect x="3.5" y="7.5" width="17" height="12.5" rx="2" />
      <path d="M9 7.5V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1.5M3.5 12.5h17M12 11v3" />
    </svg>
  );
}

/** A calendar with a day struck out: days you cannot work. */
export function TimeOffIcon() {
  return (
    <svg {...big}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4M9.5 12.5l5 5M14.5 12.5l-5 5" />
    </svg>
  );
}

/** A page with a folded corner and lines: the contractor's bills. */
export function BillsIcon() {
  return (
    <svg {...big}>
      <path d="M6 3.5h8.5L18 7v13.5H6Z" />
      <path d="M14.5 3.5V7H18M9 11h6M9 14.5h6M9 18h3.5" />
    </svg>
  );
}

/** Someone looking over the contractor's shoulder: the "View as" bar. */
export function EyeIcon() {
  return (
    <svg {...shared}>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="2.75" />
    </svg>
  );
}

/** The chevron on a card that opens, and on the way back. */
export function ChevronIcon(props: { back?: boolean }) {
  return (
    <svg {...shared} className="p-chevron">
      <path d={props.back ? 'M14.5 6 8.5 12l6 6' : 'M9.5 6l6 6-6 6'} />
    </svg>
  );
}
